<template>
  <b-modal
      id="modal-family-member-add-option"
      v-bind:hide-footer="false"
      ref="modal-family-member-add-option"
      size="lg"
      centered
      ok-title-html="<i class='fa fa-check-circle mr-2'></i>Submit"
      cancel-title-html="<i class='fa fa-times-circle mr-2'></i>Close"
      @ok="optionSubmit"
  >
    <template slot="modal-title">Please Choose</template>
    <div>
      <h5 class="ml-0 mb-3">What type of member would you like to add to the family?</h5>
      <b-form-radio-group
          v-model="option"
          name="family-add-option"
          stacked
      >
        <b-form-radio
            v-for="(opt, index) in optionsList"
            :key="index"
            :value="opt.value"
            class="mb-2"
        >
          {{ opt.text }}
        </b-form-radio>
      </b-form-radio-group>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: 'FamilyMemberAddOptionPopup',
  data() {
    return {
      option: 'existing',
      optionsList: [
        { text: 'Add Existing Member', value: 'existing' },
        { text: 'Add New Member', value: 'new' }
      ]
    }
  },
  methods: {
    optionSubmit() {
      this.$emit('decideMemberType', this.option);
    }
  }
}
</script>